if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();

        this.currentIndex = 0;

        this.scale = 1;
        this.translateX = 0;
        this.translateY = 0;

        this.minScale = 1;
        this.maxScale = 4;

        this.activePointers = new Map();

        this.pointerStartX = 0;
        this.pointerStartY = 0;
        this.startTranslateX = 0;
        this.startTranslateY = 0;

        this.pinchStartDistance = 0;
        this.pinchStartScale = 1;

        this.isDragging = false;
        this.hasPointerMoved = false;

        this.handleModalClick = this.handleModalClick.bind(this);
        this.handleKeydown = this.handleKeydown.bind(this);
        this.handleWheel = this.handleWheel.bind(this);
        this.handleDoubleClick = this.handleDoubleClick.bind(this);
        this.handlePointerDown = this.handlePointerDown.bind(this);
        this.handlePointerMove = this.handlePointerMove.bind(this);
        this.handlePointerUp = this.handlePointerUp.bind(this);
      }

      connectedCallback() {
        if (super.connectedCallback) {
          super.connectedCallback();
        }

        this.setupGalleryControls();

        this.addEventListener(
          'click',
          this.handleModalClick,
          true
        );
      }

      disconnectedCallback() {
        this.removeEventListener(
          'click',
          this.handleModalClick,
          true
        );

        document.removeEventListener(
          'keydown',
          this.handleKeydown
        );

        this.removeZoomListeners();
      }

      get mediaItems() {
        return Array.from(
          this.querySelectorAll(
            '.product-media-modal__content > [data-media-id]'
          )
        );
      }

      get activeMedia() {
  const media = this.mediaItems[this.currentIndex];

  if (!media) return null;

  if (media.tagName === 'IMG') {
    return media;
  }

  return media.querySelector('img') || media;
}

      get activeImage() {
  return this.activeMedia;
}

      setupGalleryControls() {
        if (this.dataset.galleryInitialized === 'true') {
          return;
        }

        const dialog = this.querySelector(
          '.product-media-modal__dialog'
        );

        const content = this.querySelector(
          '.product-media-modal__content'
        );

        if (!dialog || !content) {
          return;
        }

        this.dataset.galleryInitialized = 'true';
        this.content = content;

        this.previousButton = document.createElement('button');
        this.previousButton.type = 'button';
        this.previousButton.className =
          'product-modal-arrow product-modal-arrow--previous';
        this.previousButton.setAttribute(
          'aria-label',
          'Previous product image'
        );
        this.previousButton = document.createElement('button');
this.previousButton.type = 'button';
this.previousButton.className =
  'product-modal-arrow product-modal-arrow--previous';
this.previousButton.setAttribute(
  'aria-label',
  'Previous product image'
);
this.previousButton.innerHTML = `
<svg width="22" height="22" viewBox="0 0 24 24" fill="none">
  <path d="M15 18L9 12L15 6"
        stroke="currentColor"
        stroke-width="2.5"
        stroke-linecap="round"
        stroke-linejoin="round"/>
</svg>`;

this.nextButton = document.createElement('button');
this.nextButton.type = 'button';
this.nextButton.className =
  'product-modal-arrow product-modal-arrow--next';
this.nextButton.setAttribute(
  'aria-label',
  'Next product image'
);
this.nextButton.innerHTML = `
<svg width="22" height="22" viewBox="0 0 24 24" fill="none">
  <path d="M9 18L15 12L9 6"
        stroke="currentColor"
        stroke-width="2.5"
        stroke-linecap="round"
        stroke-linejoin="round"/>
</svg>`;

this.counter = document.createElement('div');
this.counter.className = 'product-modal-counter';
this.counter.setAttribute('aria-live', 'polite');

this.mobileControls = document.createElement('div');
this.mobileControls.className =
  'product-modal-mobile-controls';

dialog.appendChild(this.previousButton);
dialog.appendChild(this.nextButton);
dialog.appendChild(this.counter);
dialog.appendChild(this.mobileControls);
        this.addZoomListeners();
      }

      addZoomListeners() {
        if (!this.content) {
          return;
        }

        this.content.addEventListener(
          'wheel',
          this.handleWheel,
          { passive: false }
        );

        this.content.addEventListener(
          'dblclick',
          this.handleDoubleClick
        );

        this.content.addEventListener(
          'pointerdown',
          this.handlePointerDown
        );

        this.content.addEventListener(
          'pointermove',
          this.handlePointerMove
        );

        this.content.addEventListener(
          'pointerup',
          this.handlePointerUp
        );

        this.content.addEventListener(
          'pointercancel',
          this.handlePointerUp
        );
      }

      removeZoomListeners() {
        if (!this.content) {
          return;
        }

        this.content.removeEventListener(
          'wheel',
          this.handleWheel
        );

        this.content.removeEventListener(
          'dblclick',
          this.handleDoubleClick
        );

        this.content.removeEventListener(
          'pointerdown',
          this.handlePointerDown
        );

        this.content.removeEventListener(
          'pointermove',
          this.handlePointerMove
        );

        this.content.removeEventListener(
          'pointerup',
          this.handlePointerUp
        );

        this.content.removeEventListener(
          'pointercancel',
          this.handlePointerUp
        );
      }

      handleModalClick(event) {
        const previousArrow = event.target.closest(
          '.product-modal-arrow--previous'
        );

        const nextArrow = event.target.closest(
          '.product-modal-arrow--next'
        );

        const closeButton = event.target.closest(
          '.product-media-modal__toggle'
        );

        const dialog = event.target.closest(
          '.product-media-modal__dialog'
        );

        if (previousArrow) {
          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();

          this.showPreviousMedia();
          return;
        }

        if (nextArrow) {
          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();

          this.showNextMedia();
          return;
        }

        if (closeButton) {
          return;
        }

        if (dialog) {
          event.stopPropagation();
        }
      }

      show(opener) {
        super.show(opener);

        this.setupGalleryControls();
        this.showActiveMedia();

        document.documentElement.classList.add(
          'product-modal-is-open'
        );

        document.body.classList.add(
          'product-modal-is-open'
        );

        document.addEventListener(
          'keydown',
          this.handleKeydown
        );
      }

      hide() {
        this.resetZoom(false);

        super.hide();

        document.documentElement.classList.remove(
          'product-modal-is-open'
        );

        document.body.classList.remove(
          'product-modal-is-open'
        );

        document.removeEventListener(
          'keydown',
          this.handleKeydown
        );
      }

      showActiveMedia() {
        const mediaItems = this.mediaItems;

        if (!mediaItems.length) {
          return;
        }

        const requestedMediaId = this.openedBy
          ? this.openedBy.getAttribute('data-media-id')
          : null;

        const requestedIndex = mediaItems.findIndex(
          (media) =>
            media.getAttribute('data-media-id') ===
            requestedMediaId
        );

        this.currentIndex =
          requestedIndex >= 0 ? requestedIndex : 0;

        this.displayMedia(this.currentIndex);
      }

      displayMedia(index) {
        const mediaItems = this.mediaItems;

        if (!mediaItems.length) {
          return;
        }

        if (index < 0) {
          index = mediaItems.length - 1;
        }

        if (index >= mediaItems.length) {
          index = 0;
        }

        this.resetZoom(false);
        this.currentIndex = index;

        mediaItems.forEach((media, mediaIndex) => {
          const isActive = mediaIndex === index;

          media.classList.toggle('active', isActive);
          media.hidden = !isActive;

          media.setAttribute(
            'aria-hidden',
            isActive ? 'false' : 'true'
          );

          if (isActive) {
            media.style.display = 'flex';

            const image = media.querySelector('img');

            if (image) {
              image.draggable = false;
              image.classList.add('product-modal-zoom-image');
            }
          } else {
            media.style.display = 'none';

            media
              .querySelectorAll('video')
              .forEach((video) => video.pause());
          }
        });

        const activeMedia = mediaItems[index];

        if (
          activeMedia.nodeName === 'DEFERRED-MEDIA' &&
          typeof activeMedia.loadContent === 'function'
        ) {
          activeMedia.loadContent();
        }

        const hasMultipleImages = mediaItems.length > 1;

        if (this.previousButton) {
          this.previousButton.hidden = !hasMultipleImages;
        }

        if (this.nextButton) {
          this.nextButton.hidden = !hasMultipleImages;
        }

        if (this.counter) {
          this.counter.textContent =
            `${index + 1} / ${mediaItems.length}`;

          this.counter.hidden = !hasMultipleImages;
        }

        requestAnimationFrame(() => {
          this.applyTransform(false);
        });
      }

      showPreviousMedia() {
        this.displayMedia(this.currentIndex - 1);
      }

      showNextMedia() {
        this.displayMedia(this.currentIndex + 1);
      }

      handleWheel(event) {
        const image = this.activeImage;

        if (!image || !event.target.closest('[data-media-id]')) {
          return;
        }

        event.preventDefault();
        event.stopPropagation();

        const sensitivity = event.ctrlKey ? 0.008 : 0.0025;

        const zoomMultiplier = Math.exp(
          -event.deltaY * sensitivity
        );

        const newScale = this.scale * zoomMultiplier;

        this.setZoom(
          newScale,
          event.clientX,
          event.clientY
        );
      }

      handleDoubleClick(event) {
        const image = event.target.closest(
          '.product-modal-zoom-image'
        );

        if (!image) {
          return;
        }

        event.preventDefault();

        if (this.scale > 1.05) {
          this.resetZoom();
        } else {
          this.setZoom(
            2.5,
            event.clientX,
            event.clientY
          );
        }
      }

      handlePointerDown(event) {
  const image = this.activeImage;

  if (!image) {
    return;
  }

  if (!image.contains(event.target) && event.target !== image) {
    return;
  }

  event.preventDefault();

        this.activePointers.set(event.pointerId, {
          x: event.clientX,
          y: event.clientY
        });

        image.setPointerCapture?.(event.pointerId);

        this.pointerStartX = event.clientX;
        this.pointerStartY = event.clientY;

        this.startTranslateX = this.translateX;
        this.startTranslateY = this.translateY;

        this.hasPointerMoved = false;

        if (this.activePointers.size === 2) {
          const points = Array.from(
            this.activePointers.values()
          );

          this.pinchStartDistance =
            this.getDistance(points[0], points[1]);

          this.pinchStartScale = this.scale;
          this.isDragging = false;
        } else if (this.scale > 1) {
          this.isDragging = true;
          image.classList.add('is-dragging');
          image.style.cursor = 'grabbing';
        }
      }

      handlePointerMove(event) {
        if (!this.activePointers.has(event.pointerId)) {
          return;
        }

        event.preventDefault();

        this.activePointers.set(event.pointerId, {
          x: event.clientX,
          y: event.clientY
        });

        const points = Array.from(
          this.activePointers.values()
        );

        if (points.length >= 2) {
          const distance =
            this.getDistance(points[0], points[1]);

          if (!this.pinchStartDistance) {
            return;
          }

          const midpoint = {
            x: (points[0].x + points[1].x) / 2,
            y: (points[0].y + points[1].y) / 2
          };

          const newScale =
            this.pinchStartScale *
            (distance / this.pinchStartDistance);

          this.setZoom(
            newScale,
            midpoint.x,
            midpoint.y,
            false
          );

          this.hasPointerMoved = true;
          return;
        }

        const deltaX =
          event.clientX - this.pointerStartX;

        const deltaY =
          event.clientY - this.pointerStartY;

        if (
          Math.abs(deltaX) > 4 ||
          Math.abs(deltaY) > 4
        ) {
          this.hasPointerMoved = true;
        }

        if (this.scale > 1 && this.isDragging) {
          this.translateX =
            this.startTranslateX + deltaX;

          this.translateY =
            this.startTranslateY + deltaY;

          this.clampTranslation();
          this.applyTransform(false);
        }
      }

      handlePointerUp(event) {
        if (!this.activePointers.has(event.pointerId)) {
          return;
        }

        const endingPointer =
          this.activePointers.get(event.pointerId);

        this.activePointers.delete(event.pointerId);

        const image = this.activeImage;

        if (image) {
          image.releasePointerCapture?.(event.pointerId);
          image.classList.remove('is-dragging');
          image.style.cursor =
  this.scale > 1.01 ? 'grab' : 'zoom-in';
        }

        if (
          this.scale <= 1.01 &&
          this.activePointers.size === 0
        ) {
          const distanceX =
            endingPointer.x - this.pointerStartX;

          const distanceY =
            endingPointer.y - this.pointerStartY;

          if (
            Math.abs(distanceX) > 45 &&
            Math.abs(distanceX) > Math.abs(distanceY)
          ) {
            if (distanceX < 0) {
              this.showNextMedia();
            } else {
              this.showPreviousMedia();
            }
          }
        }

        if (this.activePointers.size === 1) {
          const remainingPointer = Array.from(
            this.activePointers.values()
          )[0];

          this.pointerStartX = remainingPointer.x;
          this.pointerStartY = remainingPointer.y;

          this.startTranslateX = this.translateX;
          this.startTranslateY = this.translateY;

          this.isDragging = this.scale > 1;
        } else {
          this.isDragging = false;
        }

        if (this.activePointers.size < 2) {
          this.pinchStartDistance = 0;
        }
      }

      setZoom(
        requestedScale,
        clientX,
        clientY,
        animate = true
      ) {
        const image = this.activeImage;

        if (!image) {
          return;
        }

        const newScale = Math.min(
          this.maxScale,
          Math.max(this.minScale, requestedScale)
        );

        const oldScale = this.scale;

        if (Math.abs(newScale - oldScale) < 0.001) {
          return;
        }

        const rect = image.getBoundingClientRect();

        const imageCenterX =
          rect.left + rect.width / 2;

        const imageCenterY =
          rect.top + rect.height / 2;

        const pointerX =
          typeof clientX === 'number'
            ? clientX
            : imageCenterX;

        const pointerY =
          typeof clientY === 'number'
            ? clientY
            : imageCenterY;

        const scaleRatio = newScale / oldScale;

        this.translateX -=
          (pointerX - imageCenterX) *
          (scaleRatio - 1);

        this.translateY -=
          (pointerY - imageCenterY) *
          (scaleRatio - 1);

        this.scale = newScale;

        if (this.scale <= 1.01) {
          this.scale = 1;
          this.translateX = 0;
          this.translateY = 0;
        }

        this.clampTranslation();
        this.applyTransform(animate);
      }

      resetZoom(animate = true) {
        this.scale = 1;
        this.translateX = 0;
        this.translateY = 0;

        this.activePointers.clear();
        this.isDragging = false;

        this.applyTransform(animate);
      }

      clampTranslation() {
        const image = this.activeImage;
        const content = this.content;

        if (!image || !content || this.scale <= 1) {
          this.translateX = 0;
          this.translateY = 0;
          return;
        }

        const baseWidth = image.offsetWidth;
        const baseHeight = image.offsetHeight;

        const scaledWidth = baseWidth * this.scale;
        const scaledHeight = baseHeight * this.scale;

        const contentWidth = content.clientWidth;
        const contentHeight = content.clientHeight;

        const maxX = Math.max(
          0,
          (scaledWidth - contentWidth) / 2 + 40
        );

        const maxY = Math.max(
          0,
          (scaledHeight - contentHeight) / 2 + 40
        );

        this.translateX = Math.min(
          maxX,
          Math.max(-maxX, this.translateX)
        );

        this.translateY = Math.min(
          maxY,
          Math.max(-maxY, this.translateY)
        );
      }

      applyTransform(animate = true) {
        const image = this.activeImage;

        if (!image) {
          return;
        }

        image.style.transition = animate
          ? 'transform 180ms ease'
          : 'none';

        image.style.transform =
          `translate3d(${this.translateX}px, ${this.translateY}px, 0) scale(${this.scale})`;

        image.classList.toggle(
          'is-zoomed',
          this.scale > 1.01
        );
        image.style.cursor =
  this.scale > 1.01 ? 'grab' : 'zoom-in';

        if (this.content) {
          this.content.classList.toggle(
            'is-image-zoomed',
            this.scale > 1.01
          );
        }
      }

      getDistance(pointA, pointB) {
        return Math.hypot(
          pointB.x - pointA.x,
          pointB.y - pointA.y
        );
      }

      handleKeydown(event) {
        if (!this.hasAttribute('open')) {
          return;
        }

        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          this.showPreviousMedia();
        }

        if (event.key === 'ArrowRight') {
          event.preventDefault();
          this.showNextMedia();
        }

        if (
          event.key === '+' ||
          event.key === '='
        ) {
          event.preventDefault();
          this.setZoom(this.scale + 0.25);
        }

        if (event.key === '-') {
          event.preventDefault();
          this.setZoom(this.scale - 0.25);
        }

        if (event.key === '0') {
          event.preventDefault();
          this.resetZoom();
        }
      }
    }
  );
}